var render = function render(){var _vm=this,_c=_vm._self._c;return (! _vm.updating)?_c('div',{attrs:{"id":null}},[_c('select',{ref:"select",staticClass:"form-control select",attrs:{"id":_vm.id},domProps:{"value":_vm.value}},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.options),function(opt){return _c('option',{domProps:{"value":opt.id,"selected":_vm.isSelected(opt)}},[_vm._v(_vm._s(opt.text))])})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }